<template>

  <div class="main main-scroll btm-menu">
    <div tabindex="-1" class="main-sidebar">
      <div class="main-sidebar__head">
        <h4 class="title">Suche</h4>
      </div>

      <div class="main-sidebar__content none" v-if="!$isMobileScreen">

        <keyword-search class="mb20" :initialValue="dataSet.query.keyword" @searchWordChanged="searchWordChanged"
          ref="searchBox" />

        <simple-select-field class="mb20" name="Was suchst du?" field-type-id="contentType"
          :values="contentTypeSelectValues" :isMultiple="false" @on-select="contentTypeChanged"
          :initialValue="currentContentTypeId == 1 ? 'Einrichtungen' : 'Angebote'" />

        <anbieter-filter v-if="contentType !== null && currentContentTypeId == 1 && sublocalityFilter !== null"
          :contentType="contentType" :selectedFilters="selectedFilters" :structuredFilters="structuredFilters"
          :sublocalityFilter="sublocalityFilter" @filterChanged="setQueryFilters" @resetAllFilters="resetAllFilters" />

        <angebote-filter v-if="contentType !== null && currentContentTypeId == 2 && sublocalityFilter !== null"
          :contentType="contentType" :selectedFilters="selectedFilters" :structuredFilters="structuredFilters"
          :sublocalityFilter="sublocalityFilter" :initialStartDate="dataSet.query.selectedStartDate"
          :initialEndDate="dataSet.query.selectedEndDate" :initialStartTime="dataSet.query.selectedStartTime"
          :initialEndTime="dataSet.query.selectedEndTime" @dateTimeChanged="setDateQuery"
          @filterChanged="setQueryFilters" @resetAllFilters="resetAllFilters" />

        <div class="clearfix"></div>

      </div>
    </div>

    <div tabindex="-1" class="main-content">
      <TitleBar v-if="contentType !== null && $isMobileScreen" :filters="allFilters" :selectedFilters="selectedFilters"
        :showContentTypeSelect="true" :contentTypeSelectValues="contentTypeSelectValues"
        :showTermin="contentType.id == 2" :showToggleFilters="contentType.id == 2" :isFixed="true"
        :contentCount="tempContentCount" :initialKeywordSearchValue="dataSet.query.keyword"
        :initialStartDate="dataSet.query.selectedStartDate" :initialEndDate="dataSet.query.selectedEndDate"
        :initialStartTime="dataSet.query.selectedStartTime" :initialEndTime="dataSet.query.selectedEndTime"
        :initialContentType="contentType.id == 1 ? 'Einrichtungen' : 'Angebote'"
        @contentFilteringFinished="filteringFinished" @resetAllFilters="resetAllFilters"
        @getNumberOfResults="getNumberOfResults" @searchWordChanged="searchWordChanged"
        @changedTimeFilters="setDateQuery" @contentTypeChanged="contentTypeChanged" />

      <div class="section content-section">
        <div class="container-fluid" v-if="dataSet.total > 0">
          <div class="row">
            <div class="col-12">
              <h5 class="mb20">{{ dataSet.total }} Ergebnisse</h5>
            </div>
          </div>
          <div class="offer-row row" v-if="dataSet.data !== null && dataSet.data.length > 0" :data-content-type="currentContentTypeId">
            <div class="col-12 col-md-6 col-lgs-6 col-lg-6 col-xls-6 col-xl-4 d-flex align-items-stretch"
              v-if="currentContentTypeId == 2" v-for="(item, index) in dataSet.data" :key="index"
              :data-angebot-id="item.id"
              @click="onItemClick(item.id)">
              <angebot-card :item="item" :noslider="true" @itemClick="onItemClick" />
            </div>

            <div class="col-12 col-sm-6 col-xl-4 cards" v-if="currentContentTypeId == 1"
              v-for="(item, index) in dataSet.data" :key="`key${index}`"
              :data-ort-id="item.id"
              @click="onItemClick(item.id)">
              <anbieter-card :item="item" :autoWidth="true" @itemClick="onItemClick" />
            </div>

          </div>
          <pagination v-if="dataSet.total > 12" break-view-link-class="break-style" :page-count="dataSet.meta.last_page"
            :click-handler="changePage" containerClass="pagination" prev-text="&laquo" next-text="&raquo" />
        </div>
        <div v-else class="search-no-results">
          <img src="/assets/search-no-result.png" alt="Keine Ergebnisse gefunden">
          <h5 class="mt20">Keine Ergebnisse gefunden</h5>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Resource from '@/api/resource';
import { getSublocalities } from '@/api/system';
import { getContentsOfType } from '@/api/content';
import { getCtype } from '@/api/contentType';
const contentTypeResource = new Resource('contenttypes');
import { screenSizeMixin } from '@/mixins/screenSizeMixin';
import { showLoader, hideLoader, isset, getStructuredFilters, getCurrentFilterSignature, saveLastVisitedItem, attemptScrollToLastVisited } from '@/utils/helpers';
import { addZero, getReadableTime, getFilterDate, compareAndSwitchDates, getWeekday, getMonth } from '@/utils/appointment-helpers';

export default {
  name: 'Suche',
  mixins: [screenSizeMixin],
  components: {
    TitleBar: () => import('@/components/controls/TitleBar/TitleBar.vue'),
    ContentSection: () => import('./components/ContentSection.vue'),
    KeywordSearch: () => import('@/components/controls/KeywordSearch'),
    SimpleSelectField: () => import('@/components/controls/SimpleSelectField.vue'),
    AngeboteFilter: () => import('@/components/filters/angebote.vue'),
    AnbieterFilter: () => import('@/components/filters/anbieter.vue'),
    AngebotCard: () => import('@/components/cards/Angebot.vue'),
    AnbieterCard: () => import('@/components/cards/Ort.vue'),
    Pagination: () => import('@/components/controls/Pagination'),
  },
  data() {
    return {
      loader: null,
      tempShowHide: true,
      isMobileView: false,
      searchWord: '',
      sublocalities: null,
      showResults: false,
      awaitingSearch: false,
      numberOfResults: 0,
      tempContentCount: 0,
      contentType: null,
      selectedFilters: new Map(),
      currentContentTypeId: this.$offerId,
      hasInitiallyFetched: false,
      isLoadingContents: false,
      isLoadingContentType: false,
      contentTypeSelectValues: [
        { label: "Angebote", value: this.$offerId },
        { label: "Einrichtungen", value: this.$institutionId }
      ],
      dataSet: {
        total: 0,
        data: [],
        meta: null,
        query: {
          page: 1,
          type: "teaser",
          limit: 12,
          keyword: '',
          filters: null,
          selectedEndDate: null,
          selectedStartDate: null,
          selectedStartTime: null,
          appId: this.$appId,
          selectedEndTime: null,
          selectedContentTypeId: this.$offerId,
          view_status: 1
        },
      },
    }
  },
  watch: {
    $screenWidth(newWidth) {
      if (newWidth <= 991) {
        this.isMobileView = true;
      }
      else {
        this.isMobileView = false;
      }
    },
    isMobileView(newValue, oldValue) {
      /*resetting the filters if the view changes from mobile to desktop*/
      if (newValue !== oldValue) {
        this.resetAllFilters();
        this.selectedFilters = new Map();
      }
    },
    // Watch for sublocalityFilter to become available and restore filters
    sublocalityFilter(newValue, oldValue) {
      if (newValue && !oldValue) {
        // If we have URL parameters but haven't restored filters yet, do it now
        if (this.$route.query.filters && this.selectedFilters.size === 0) {
          this.restoreFiltersFromUrl();
        }
      }
    }
  },
  mounted() {

    // Check URL parameters and set content type BEFORE making any API calls
    if (this.$route.query.contentType) {
      const contentTypeId = parseInt(this.$route.query.contentType);
      if (!isNaN(contentTypeId)) {
        this.currentContentTypeId = contentTypeId;
        this.dataSet.query.selectedContentTypeId = contentTypeId;
      }
    }

    this.getContentType();
  },
  computed: {
    sublocalityFilter() {
      if (this.sublocalities !== null) {
        var bla = {};
        bla.field_type_id = "location";
        bla.label = "Stadtteile";
        bla.options = []
        for (var i = 0; i < this.sublocalities.length; i++) {
          bla.options.push({ label: this.sublocalities[i].sublocality, value: this.sublocalities[i].sublocality });
        }
        return bla;
      }
      return null;
    },
    structuredFilters() {
      return getStructuredFilters(this.contentType);
    },
    allFilters() {
      return this.structuredFilters.concat(this.sublocalityFilter);
    },
    keyword() {
      return this.$route.query.keyword;
    },
  },
  methods: {
    updateUrlParams() {
      // Build query object with all current filter parameters
      const query = {};

      // Add keyword if it exists
      if (this.dataSet.query.keyword && this.dataSet.query.keyword.trim() !== '') {
        query.keyword = this.dataSet.query.keyword;
      }

      // Add content type if not default
      if (this.currentContentTypeId !== this.$offerId) {
        query.contentType = this.currentContentTypeId;
      }

      // Add filters if they exist
      if (this.selectedFilters.size > 0) {
        query.filters = JSON.stringify(Array.from(this.selectedFilters.entries()));
      }

      // Add page if not the first page
      if (this.dataSet.query.page > 1) {
        query.page = this.dataSet.query.page;
      }

      // Add date/time filters if they exist (for Angebote)
      if (this.dataSet.query.selectedStartDate) {
        query.startDate = this.dataSet.query.selectedStartDate;
      }
      if (this.dataSet.query.selectedEndDate) {
        query.endDate = this.dataSet.query.selectedEndDate;
      }
      if (this.dataSet.query.selectedStartTime && this.dataSet.query.selectedStartTime !== 'NaN:NaN') {
        query.startTime = this.dataSet.query.selectedStartTime;
      }
      if (this.dataSet.query.selectedEndTime && this.dataSet.query.selectedEndTime !== 'NaN:NaN') {
        query.endTime = this.dataSet.query.selectedEndTime;
      }

      // Update URL using Vue Router
      if (JSON.stringify(query) !== JSON.stringify(this.$route.query)) {
        this.$router.replace({ query }).catch(() => {
          // Ignore navigation duplicated errors
        });
      }
    },
    restoreFiltersFromUrl() {
      const query = this.$route.query;
      let shouldGetContents = false;

      // Skip if we're still loading content type to avoid race conditions
      if (this.isLoadingContentType) {
        return;
      }

      // Restore keyword
      if (query.keyword !== undefined) {
        if (this.dataSet.query.keyword !== query.keyword) {
          this.dataSet.query.keyword = query.keyword || '';
          shouldGetContents = true;
        }
      }

      // Note: Content type is now handled in mounted() to avoid race conditions

      // Restore filters
      if (query.filters) {
        const filters = this.argsFilterMapToJSMap(query.filters);
        if (filters) {
          // Use the same simple approach as other working pages
          this.selectedFilters = filters;
          this.dataSet.query.filters = JSON.stringify(Array.from(this.selectedFilters.entries()));
          shouldGetContents = true;
        }
      } else if (this.selectedFilters.size > 0) {
        // Clear filters if not in URL
        this.selectedFilters = new Map();
        this.dataSet.query.filters = null;
        shouldGetContents = true;
      }

      // Restore page
      if (query.page) {
        const page = parseInt(query.page);
        if (!isNaN(page) && this.dataSet.query.page !== page) {
          this.dataSet.query.page = page;
          shouldGetContents = true;
        }
      } else if (this.dataSet.query.page !== 1) {
        this.dataSet.query.page = 1;
        shouldGetContents = true;
      }

      // Restore date/time filters (for Angebote)
      if (query.startDate !== undefined) {
        if (this.dataSet.query.selectedStartDate !== query.startDate) {
          this.dataSet.query.selectedStartDate = query.startDate || null;
          shouldGetContents = true;
        }
      }
      if (query.endDate !== undefined) {
        if (this.dataSet.query.selectedEndDate !== query.endDate) {
          this.dataSet.query.selectedEndDate = query.endDate || null;
          shouldGetContents = true;
        }
      }
      if (query.startTime !== undefined) {
        if (this.dataSet.query.selectedStartTime !== query.startTime) {
          this.dataSet.query.selectedStartTime = query.startTime || null;
          shouldGetContents = true;
        }
      }
      if (query.endTime !== undefined) {
        if (this.dataSet.query.selectedEndTime !== query.endTime) {
          this.dataSet.query.selectedEndTime = query.endTime || null;
          shouldGetContents = true;
        }
      }


      if ((shouldGetContents || !this.hasInitiallyFetched) && this.contentType) {
        this.tempShowHide = false;
        this.getContents();
      }
    },
    argsFilterMapToJSMap(args) {
      var filters = null;
      if (isset(args)) {
        /*decode them*/
        filters = decodeURIComponent(args);
        /*this should give us something better than a string*/
        filters = JSON.parse(filters);
      }

      var filterMap = new Map();
      if (isset(filters) && filters.length > 0) {
        for (var i = 0; i < filters.length; i++) {
          filterMap.set(filters[i][0], filters[i][1]);
        }
        return filterMap;
      }
      return null;
    },
    showLoader,
    hideLoader,
    filteringFinished(map) {
      /*get's invoked when the user closes the more-filters-modal with the show results-btn this also means, that we'll have to start searching now*/
      this.tempShowHide = false;
      this.selectedFilters = map;
      this.dataSet.query.page = 1;
      this.dataSet.query.filters = JSON.stringify(Array.from(this.selectedFilters.entries()));
      this.updateUrlParams();
      this.getContents();
    },
    changePage(page) {
      this.tempShowHide = false;
      this.dataSet.query.page = page;
      this.updateUrlParams();
      this.getContents();
    },
    setDateQuery(dateTimeSelection) {
      this.tempShowHide = false;
      this.dataSet.query.page = 1;
      this.dataSet.query.selectedStartDate = getFilterDate(dateTimeSelection.selectedStartDate);
      this.dataSet.query.selectedEndDate = getFilterDate(dateTimeSelection.selectedEndDate);
      this.dataSet.query.selectedStartTime = getReadableTime(dateTimeSelection.selectedStartTime);
      this.dataSet.query.selectedEndTime = getReadableTime(dateTimeSelection.selectedEndTime);
      this.updateUrlParams();
      this.getContents();
    },
    receiveNumberOfResults(number) {
      this.numberOfResults = this.numberOfResults + number;
    },
    searchWordChanged(word) {
      this.tempShowHide = false;
      this.dataSet.query.page = 1;
      this.dataSet.query.keyword = word;
      this.updateUrlParams();
      this.getContents();
    },
    contentTypeChanged(value) {
      this.tempShowHide = false;
      // Reset loading flags when changing content type
      this.isLoadingContents = false;
      this.isLoadingContentType = false;
      this.hasInitiallyFetched = false;
      this.dataSet.query.page = 1;
      this.currentContentTypeId = value.value;
      this.dataSet.query.selectedContentTypeId = this.currentContentTypeId;
      this.updateUrlParams();
      this.getContentType();
      this.resetAllFilters();
    },
    setQueryFilters() {
      this.tempShowHide = false;
      this.dataSet.query.page = 1;
      this.dataSet.query.filters = JSON.stringify(Array.from(this.selectedFilters.entries()));
      this.updateUrlParams();
      this.getContents();
    },
    resetAllFilters() {
      this.tempShowHide = false;
      this.selectedFilters = new Map;
      this.dataSet.query.keyword = ''; // Reset search keyword
      this.dataSet.query.selectedStartDate = null;
      this.dataSet.query.selectedEndDate = null;
      this.dataSet.query.selectedStartTime = null;
      this.dataSet.query.selectedEndTime = null;
      this.dataSet.query.page = 1;
      this.dataSet.query.filters = null;
      this.updateUrlParams();
      this.getContents();
    },
    async getTheSublocalities() {
      var id = this.currentContentTypeId;
      getSublocalities(this.$city, null, id).then(response => {
        this.sublocalities = response;
      });
    },
    getContentType() {

      // Prevent concurrent calls
      if (this.isLoadingContentType) {
        return;
      }

      this.isLoadingContentType = true;
      this.contentType = null;
      var id = this.currentContentTypeId;
      this.loader = this.showLoader(this.loader);
      /*overwrite the existing filters*/
      getCtype(id, this.$store.getters.getLanguage).then(response => {
        this.contentType = response.data;
        this.isLoadingContentType = false; // Reset loading flag BEFORE calling restoreFiltersFromUrl
        // Restore filters from URL after content type is loaded
        this.restoreFiltersFromUrl();
      })
        .finally(() => {
          this.loader = this.hideLoader(this.loader);
          this.getTheSublocalities();
          // Only call getContents if we don't have URL parameters to restore
          // If we have URL params, restoreFiltersFromUrl will handle calling getContents
          const hasUrlParams = this.$route.query.filters || this.$route.query.keyword ||
            this.$route.query.page || this.$route.query.startDate ||
            this.$route.query.endDate || this.$route.query.startTime ||
            this.$route.query.endTime;

          if (!this.hasInitiallyFetched && !hasUrlParams) {
            this.getContents();
          }
        });
    },

    getContents() {
      // Prevent concurrent calls
      if (this.isLoadingContents) {
        return;
      }

      this.isLoadingContents = true;
      this.dataSet.query.type = "view";
      var contentLoader = this.showLoader();

      const { limit, page } = this.dataSet.query;
      getContentsOfType(this.currentContentTypeId, this.dataSet.query, this.$store.getters.getLanguage).then(response => {
        const { data, meta } = response;
        this.dataSet.data = data;
        this.dataSet.data.forEach((element, index) => {
          element['index'] = (page - 1) * limit + index + 1;
        });
        this.dataSet.meta = meta;
        this.dataSet.total = meta.total;
        this.tempContentCount = meta.total;
        this.hasInitiallyFetched = true; // Mark that we've made the initial fetch
      })
        .catch(error => {
          console.error('❌ [SEARCH] API error:', error);
        })
        .finally(() => {
          contentLoader = this.hideLoader(contentLoader);
          this.tempShowHide = true;
          this.isLoadingContents = false; // Reset loading flag
          
          // Attempt to scroll to last visited item after data is loaded
          this.$nextTick(() => {
            this.attemptScrollToLastVisited();
          });
        });
    },
    getNumberOfResults(map) {
      /*tempFilters will contain all the filters set for now but only for the purpose of calculating the number of items found for these filtersettings*/
      var tempFilters = new Map([...this.selectedFilters, ...map]);
      /*#todo: we'll have to start a call to the backend to find out how many values there are for this selection*/
      this.getNumberOfContentsMatchingTheFilter(tempFilters);
    },
    getNumberOfContentsMatchingTheFilter(tempFilters) {
      this.dataSet.query.type = "count";
      this.dataSet.query.filters = JSON.stringify(Array.from(tempFilters.entries()));
      var contentLoader = this.showLoader();
      getContentsOfType(this.currentContentTypeId, this.dataSet.query, this.$store.getters.getLanguage).then(response => {
        this.tempContentCount = response;
      })
        .finally(() => {
          contentLoader = this.hideLoader(contentLoader);
        });
    },
    onItemClick(itemId) {
      // Save the clicked item for auto-scroll when returning
      console.log('[SEARCH] Item clicked:', itemId);
      const filterSignature = getCurrentFilterSignature(this.$route, this.selectedFilters, this.currentContentTypeId, false);
      saveLastVisitedItem(itemId, filterSignature, 'search');
    },
    attemptScrollToLastVisited() {
      // Attempt to scroll to the last visited item
      console.log('[SEARCH] Attempting scroll to last visited item');
      const filterSignature = getCurrentFilterSignature(this.$route, this.selectedFilters, this.currentContentTypeId, false);
      attemptScrollToLastVisited('search', filterSignature);
    },
  }
}
</script>
<style lang="scss" scoped>
@import '@/scss/_mixins.scss';
@import '@/scss/_variables.scss';

.content-section {
  @media (max-width: 991px) {
    margin-top: 180px;
  }
}

.cards {
  @media (max-width: 1600px) {
    flex: 0 0 50%;
    max-width: 50%;
  }

  @media (min-width: 992px) and (max-width: 1250px) {
    flex: 0 0 100%;
    max-width: 100%;
  }

  @media (max-width: 750px) {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

.search-view {
  margin-bottom: calc(#{$footer-sm-size} + #{$mobile-menu-size});

  @media (max-width: 991px) {
    margin-bottom: #{$mobile-menu-size}
  }

  .main-sidebar {
    margin-bottom: calc(#{$footer-sm-size} + #{$mobile-menu-size});
  }

  .guide-article__top-img {
    @media (max-width: 991px) {
      height: 150px;
      width: 150px;
    }

    @media (max-width: 660px) {
      min-width: 150px;
    }
  }

}

.search-no-results {
  margin-top: 80px;
  text-align: center;
}
</style>